import EventEmitter from '../utils/EventEmitter';
import dispatcher from '../dispatcher';

var directionVector = [0, 0];
var speed = 0;
var defaultSpeedCoef = 10;
var speedCoef = defaultSpeedCoef;

var forced = false;
var needsUpdate = false;

var smoothPosition = {
	x: 0,
	y: 0
}
var cursorPosition = {
	x: 0,
	y: 0
}
var target = {
	x: 0,
	y: 0
}

var eventEmitter = new EventEmitter();

var _handleEvent = function(e) {
	if (e.type === 'cursor:show') {
		forced = false;
	}
	if (e.type === 'cursor:set-smooth-position') {
		if (!e.position) return;
		needsUpdate = true;
		smoothPosition.x = e.position.x;
		smoothPosition.y = e.position.y;
		speed = 0;
		directionVector = [0, 0];
	}
	if (e.type === 'cursor:force-position') {
		needsUpdate = true;
		target.x = e.position.x;
		target.y = e.position.y;
		forced = true;
	}
	if (e.type === 'cursor:free-position'
		|| e.type === 'content:replaced') {
		forced = false;
	}
}

var _handleMouseMove = function(e) {
	cursorPosition.x = e.clientX;
	cursorPosition.y = e.clientY;

	if (forced) return;

	target.x = e.clientX;
	target.y = e.clientY;
}

var _loop = function() {
	var moveEvent;
	var oldCoords = {
		x: smoothPosition.x,
		y: smoothPosition.y
	}
	var dl;

	smoothPosition.x += (target.x - smoothPosition.x) / speedCoef;
	smoothPosition.y += (target.y - smoothPosition.y) / speedCoef;

	speed = Math.pow(Math.pow(oldCoords.x - smoothPosition.x, 2)
		+ Math.pow(oldCoords.y - smoothPosition.y, 2), 0.5);

	// normalized direction
	directionVector = [
		smoothPosition.x - oldCoords.x,
		smoothPosition.y - oldCoords.y
	];
	dl = Math.pow(Math.pow(directionVector[0], 2) + Math.pow(directionVector[1], 2), 0.5);
	directionVector = [
		directionVector[0] / dl,
		directionVector[1] / dl
	]

	if (isNaN(directionVector[0])) {
		directionVector[0] = 0;
	}
	if (isNaN(directionVector[1])) {
		directionVector[1] = 0;
	}

	if (speed > 0.01 || needsUpdate) {
		needsUpdate = false;
		eventEmitter.dispatch();
	}
	requestAnimationFrame(_loop);
}

var getData = function() {
	return {
		directionVector: directionVector,
		speed: speed,
		forced: forced,
		smoothPosition: smoothPosition,
		cursorPosition: cursorPosition,
		target: target
	}
}

var _init = function() {
	window.addEventListener('mousemove', _handleMouseMove, {passive: true});
	dispatcher.subscribe(_handleEvent);
	_loop();
}

_init();

export default {
	subscribe: eventEmitter.subscribe.bind(eventEmitter),
	unsubscribe: eventEmitter.unsubscribe.bind(eventEmitter),
	getData: getData
}